// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"2441":"818548e7203b55d23717","5862":"64a2c950a5aee9226eb1","6189":"74c27de7e7e9965fc2aa"}[chunkId] + "";
};